import { interceptor } from '@/common/utils/interceptor';
import * as Constants from '@/common/utils/constants';

export default [
  // 处方查询
  {
    path: '/query/prescription',
    component: () => import('@/pages/query/prescription'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      // 处方查询详情
      {
        path: 'detail',
        component: () => import('@/pages/query/prescription-detail'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  },
  // 门诊、住院费用
  {
    path: '/query/payment',
    component: () => import('@/pages/query/payment'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      // 门诊、住院费用详情
      {
        path: 'detail',
        component: () => import('@/pages/query/payment-detail'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  },
  // 住院日清单
  {
    path: '/query/payment-day',
    component: () => import('@/pages/query/payment-day'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    }
  },
  { // 门诊、住院报告
    path: '/query/report',
    component: () => import('@/pages/query/report'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      { // 门诊、住院报告详情
        path: 'detail',
        component: () => import('@/pages/query/report-detail'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  },
  // 出院带药
  {
    path: '/query/discharge-medicine',
    component: () => import('@/pages/query/discharge-medicine'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      // 出院带药详情
      {
        path: 'detail',
        component: () => import('@/pages/query/discharge-medicine-detail'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  },
  // 病理报告
  {
    path: '/query/pathology',
    component: () => import('@/pages/query/pathology'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      // 病理报告详情
      {
        path: 'detail',
        component: () => import('@/pages/query/pathology-detail'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  },
  // 门诊 、住院云胶片
  {
    path: '/query/cloud-film',
    component: () => import('@/pages/query/cloud-film'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    }
  },
  // 物价查询
  {
    path: '/query/price',
    component: () => import('@/pages/query/price'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      // 物价查询详情
      {
        path: 'detail',
        component: () => import('@/pages/query/price-detail'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  },
  // 门诊、住院病历查询
  {
    path: '/query/case',
    component: () => import('@/pages/query/case'),
    beforeEnter: (to, from, next) => {
      interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
    },
    children: [
      // 门诊、住院病历查询详情
      {
        path: 'detail',
        component: () => import('@/pages/query/case-detail'),
        beforeEnter: (to, from, next) => {
          interceptor(to, from, next, Constants.LOGIN_TYPE_LOGIN);
        }
      }
    ]
  }
];
